import { ICellRendererParams } from 'ag-grid-community';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getTerritoryFlagRenderer } from 'src/util/grid/cellRenderer';

const commonColDef = {
    cellStyle: { borderRight: '1px solid #dde2eb' },
    wrapHeaderText: true,
    autoHeaderHeight: true
};

export const fullRatesColDefs = [
    {
        field: 'territory',
        headerName: 'Territory',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, false),
        ...commonColDef
    },
    {
        field: 'region',
        headerName: 'Region',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'rateCardCurrency',
        headerName: 'Ratecard ccy',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'settlementCurrency',
        headerName: 'Settlement ccy',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'cae',
        headerName: 'CAE',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'displayName',
        headerName: 'Plan',
        filter: 'agSetColumnFilter',
        width: 300,
        ...commonColDef
    },
    {
        field: 'paperPlanName',
        headerName: 'PAPER plan ID',
        filter: 'agSetColumnFilter',
        width: 400,
        ...commonColDef
    },
    {
        field: 'rateGroup',
        headerName: 'Rate group',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'rateType',
        headerName: 'Rate type',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'rate',
        headerName: 'Rate',
        filter: 'agNumberColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'tier2Rate',
        headerName: 'Tier 2 rate',
        filter: 'agNumberColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'tier3Rate',
        headerName: 'Tier 3 rate',
        filter: 'agNumberColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    },
    {
        field: 'serviceRev',
        headerName: 'Service rev',
        filter: 'agNumberColumnFilter',
        valueFormatter: emptyCellFormatter,
        ...commonColDef
    }
];
